import React from 'react';

/** Shimmering placeholder block (uses the .admin-skeleton shimmer). */
export function Skeleton({ className = '' }: { className?: string }) {
  return <div className={`admin-skeleton ${className}`} aria-hidden />;
}

/** A stack of row-shaped skeletons — drop-in table/list loading state. */
export function SkeletonRows({ rows = 6, className = '' }: { rows?: number; className?: string }) {
  return (
    <div className={`space-y-2 ${className}`} aria-hidden>
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} className="admin-skeleton h-9 w-full" style={{ opacity: 1 - i * 0.09 }} />
      ))}
    </div>
  );
}

/** A grid of card-shaped skeletons — dashboard/stat loading state. */
export function SkeletonCards({ cards = 3, className = '' }: { cards?: number; className?: string }) {
  return (
    <div className={`grid gap-4 ${className}`} style={{ gridTemplateColumns: `repeat(auto-fit, minmax(180px, 1fr))` }} aria-hidden>
      {Array.from({ length: cards }, (_, i) => (
        <div key={i} className="admin-skeleton h-[110px] w-full" style={{ opacity: 1 - i * 0.07 }} />
      ))}
    </div>
  );
}
